import { render, staticRenderFns } from "./tipoViviendas.vue?vue&type=template&id=476e03c0&scoped=true"
import script from "./tipoViviendas.vue?vue&type=script&lang=js"
export * from "./tipoViviendas.vue?vue&type=script&lang=js"
import style0 from "./tipoViviendas.vue?vue&type=style&index=0&id=476e03c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e03c0",
  null
  
)

export default component.exports